import type { MetaFunction } from "@remix-run/node";
import DevicePhoneMobileIcon from "@heroicons/react/24/solid/esm/DevicePhoneMobileIcon";
import EnvelopeIcon from "@heroicons/react/24/solid/esm/EnvelopeIcon";
import { Form, redirect, useLoaderData } from "@remix-run/react";

import React from "react";

import { getPageTitle } from "~/operations/getPageTitle";
import { Field, Label } from "~/components/base/fieldset";
import { checkIsValidPhoneNumber } from "~/operations/checkIsValidPhoneNumber";
import { Input } from "~/components/base/input";
import { action } from "./action";
import { SubmitButton } from "~/components/submitButton";
import { loader } from "./loader";
export { action, loader };

export const meta: MetaFunction = () => {
  return [{ title: getPageTitle("Login") }];
};

export default function LoginIndex() {
  const data = useLoaderData<typeof loader>();

  const [usingSMS, setUsingSMS] = React.useState(false);
  const searchParams = new URLSearchParams({ index: "" });

  if (usingSMS) {
    searchParams.set("usingSMS", "");
  }

  if (data?.redirect) {
    searchParams.append("redirect", data?.redirect);
  }

  return (
    <Form
      className="space-y-6"
      action={`/auth/login?${searchParams.toString()}`}
      method="post"
      noValidate={usingSMS}
    >
      {data.mismatch && (
        <h3 className="mt-6 text-center text-xl font-bold leading-9 tracking-tight text-red-500">
          Users did not match. Please login again.
        </h3>
      )}
      <Field>
        <Label>Enter your E-mail address or phone number.</Label>
        <Input
          type={usingSMS ? "tel" : "email"}
          name={usingSMS ? "phone" : "email"}
          required
          autoFocus
          placeholder=""
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = e.target.value;
            setUsingSMS(checkIsValidPhoneNumber(newValue));
          }}
        />
      </Field>
      <SubmitButton
        className="w-full"
        busyContent={"Getting Code..."}
        idleIcon={usingSMS ? <DevicePhoneMobileIcon /> : <EnvelopeIcon />}
        idleContent={"Get Code"}
      />
    </Form>
  );
}
